import { PositionCode } from '@youyan/common';
import type { IEquity } from '~/api/interface/rights';
import { showDynamicContact } from '~/hooks/useModal/modals/contact';
import BaseState, { type ITitleClass } from './base';
import CornerMark from './corner-mark.vue';

/** 企业版 */
export default class Rights24 extends BaseState {
  TitleView = defineComponent({
    name: 'TitleView24',
    props: {
      titleClass: {
        type: Object as PropType<ITitleClass>,
        required: true,
      },
      rights: {
        type: Object as PropType<IEquity>,
        required: true,
      },
      hovered: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    setup(props) {
      const { rights } = props;
      const { $t } = useNuxtApp();
      return () => (
        <>
          <div>
            <div class="title-name">{rights.rights_name}</div>
          </div>
          <div class="sub-title">{rights.subject}</div>
          {isChinese() ? <CornerMark text={$t('qi-ye-shang-yong-shou-quan')} /> : null}
        </>
      );
    },
  });

  get PriceView() {
    const { $t } = useNuxtApp();

    return (
      <div class={!isChinese() ? 'pt-[33px] pb-[16px] text-[#FFEABF]' : 'pt-[38px] pb-[34px]'}>
        <div class="text-[28px] font-bold leading-[36px]">{$t('zi-xun-ding-zhi')}</div>
        {!isChinese() && <div class="text-14">Contact sales for more details</div>}
      </div>
    );
  }

  get ButtonView() {
    const { $t } = useNuxtApp();

    if (this.isUserLogin) {
      return this.getButton({
        text: $t('zi-xun-gu-wen'),
        cb: this.openContact,
      });
    }
    return this.getButton({
      text: $t('le-jie-geng-duo'),
      cb: this.openContact,
    });
  }

  get StickyButtonView() {
    const { $t } = useNuxtApp();

    if (this.isUserLogin) {
      return this.getButton({
        text: $t('zi-xun-gu-wen'),
        cb: this.openContact,
      });
    }
    return this.getButton({
      text: $t('le-jie-geng-duo'),
      cb: this.openContact,
    });
  }

  openContact() {
    showDynamicContact(PositionCode['有言官网-付费订阅-咨询定制']); // @xi18n-ignore
  }
}
